import { render, staticRenderFns } from "./ComboPlanos.vue?vue&type=template&id=75352f82"
import script from "./ComboPlanos.vue?vue&type=script&lang=ts"
export * from "./ComboPlanos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports